import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { QualityApprovalsTabPanel } from "@/screens/Dashboard/components/QualityApprovalsTabPanel"
import { qualityApprovalSearchSchema } from "@/screens/Dashboard/schemas"

export const Route = createFileRoute("/app/dashboard/_layout/pending-approvals/_layout/quality")({
  validateSearch: zodValidator(qualityApprovalSearchSchema),
  search: {
    middlewares: [retainSearchParams(["taskViewScope"])],
  },
  component: () => <QualityApprovalsTabPanel />,
})
